import React from 'react'

import {
  array,
  string,
  arrayOf,
  shape,
} from 'prop-types'

import i18n from 'Pods/Shared/I18nHome'
import { modelsPath } from 'Pods/Shared/paths'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import AssetCollection from './Components/AssetCollection'

function AssetCategory({ locale = 'en', itemCategories = EMPTY_ARRAY, trending = EMPTY_ARRAY }) {
  const title = i18n.t('assetCategory.title', {
    ns: 'new-home',
    lng: locale,
  })
  const description = i18n.t('assetCategory.description', {
    ns: 'new-home',
    lng: locale,
  })
  const browseButton = i18n.t('assetCategory.browseButton', {
    ns: 'new-home',
    lng: locale,
  })

  const allCategoriesText = i18n.t('assetCategory.allCategories', {
    ns: 'new-home',
    lng: locale,
  })

  const browseAllHref = modelsPath(locale, { licenses: ['exclude_3d_print'] })

  return (
    <AssetCollection
      id="asset-category"
      title={title}
      description={description}
      trendingButtons={trending}
      items={itemCategories}
      browseAllHref={browseAllHref}
      browseAllText={browseButton}
      collectionType="asset-category"
      customWrapperClass="new-home-section"
      allCategoriesText={allCategoriesText}
      locale={locale}
    />
  )
}

AssetCategory.propTypes = {
  locale: string,
  itemCategories: array,
  trending: arrayOf(
    shape({
      name: string,
      url: string,
    })
  ),
}

AssetCategory.displayName = 'AssetCategory'

export default AssetCategory
